/**
 * User Profile API
 * მომხმარებლის პროფილის API
 */

import { get, put, patch, del } from '@aiia/portal-core';

export type EntityType = 'INDIVIDUAL' | 'LEGAL_ENTITY';

export interface User {
  id: string;
  email: string;
  entityType: EntityType;
  firstName?: string;
  lastName?: string;
  personalId?: string;
  companyName?: string;
  companyId?: string;
  phone?: string;
  address?: string;
  displayName?: string;
  language?: string;
  profileComplete: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateProfileRequest {
  entityType?: EntityType;
  firstName?: string;
  lastName?: string;
  personalId?: string | null;
  companyName?: string | null;
  companyId?: string | null;
  phone?: string;
  address?: string;
  language?: string;
}

export interface ProfileStatus {
  complete: boolean;
  entityType?: EntityType;
}

// Get current user profile
export const getCurrentUser = () =>
  get<User>('/users/me');

// Update current user profile
export const updateProfile = (data: UpdateProfileRequest) =>
  put<User>('/users/me', data);

// Update language preference
export const updateLanguage = (language: string) =>
  patch<User>('/users/me/language', { language });

// Get profile completion status
export const getProfileStatus = () =>
  get<ProfileStatus>('/users/me/profile-status');

// Delete current user account
export const deleteAccount = () =>
  del<void>('/users/me');
